import { DefaultRequestAction } from './types';

//TODO: change this to follow the facesheet structure from types.ts at the time of data mapping
export const DUMMY_FACESHEET_OPTIONS = [
  { value: 'fgs_config_full', label: 'FGS Config Full & HIE' },
  { value: 'fgs_config_basic', label: 'FGS Config Basic' },
  { value: 'hie_summary', label: 'HIE Summary Sheet' },
] as const;

//https://gitlab.com/memr/core-api/-/blob/develop/src/modules/organizations/enums/retrieval-method.ts?ref_type=heads
export enum RetrievalMethod {
  FACESHEETS = 'FACESHEETS',
  HIE = 'HIE',
  MEDICATIONS = 'MEDICATIONS',
  PROVIDER_FACILITY = 'FULL',
  RECORD_UPLOAD = 'RECORD_UPLOAD',
}

// TEMP name for the actions object, will change after the patient request refactor for actions.
export const ACTIONS: Record<RetrievalMethod, DefaultRequestAction> = {
  [RetrievalMethod.HIE]: {
    name: RetrievalMethod.HIE,
    displayName: 'Digital Health Data',
    isEnabled: true,
    validationFields: ['zipCodes'],
    category: 'Records & Data',
  },
  [RetrievalMethod.MEDICATIONS]: {
    name: RetrievalMethod.MEDICATIONS,
    displayName: 'Medications Data',
    isEnabled: false,
    category: 'Records & Data',
  },
  [RetrievalMethod.PROVIDER_FACILITY]: {
    name: RetrievalMethod.PROVIDER_FACILITY,
    displayName: 'Provider/Facility Retrieval',
    isEnabled: false,
    validationFields: ['requestFrom', 'releasedTo', 'retrieveFrom'],
    category: 'Records & Data',
  },
  [RetrievalMethod.FACESHEETS]: {
    name: RetrievalMethod.FACESHEETS,
    displayName: 'Facesheets',
    isEnabled: false,
    validationFields: ['selectedFacesheets'],
    category: 'Analysis',
  },
  [RetrievalMethod.RECORD_UPLOAD]: {
    name: RetrievalMethod.RECORD_UPLOAD,
    displayName: 'Record Upload',
    isEnabled: false,
    validationFields: ['uploadedFiles'],
    category: 'Records & Data',
  },
};

export const DEFAULT_REQUEST_ACTIONS: DefaultRequestAction[] = [
  {
    name: RetrievalMethod.HIE,
    displayName: 'Digital Health Data',
    isEnabled: true,
    validationFields: ['zipCodes'],
    category: 'Records & Data',
  },
  {
    name: RetrievalMethod.MEDICATIONS,
    displayName: 'Medications Data',
    isEnabled: false,
    category: 'Records & Data',
  },
  {
    name: RetrievalMethod.PROVIDER_FACILITY,
    displayName: 'Provider/Facility Retrieval',
    isEnabled: false,
    validationFields: ['requestFrom', 'releasedTo', 'retrieveFrom'],
    category: 'Records & Data',
  },
  {
    name: RetrievalMethod.FACESHEETS,
    displayName: 'Facesheets',
    isEnabled: false,
    validationFields: ['selectedFacesheets'],
    category: 'Analysis',
  },
  {
    name: RetrievalMethod.RECORD_UPLOAD,
    displayName: 'Record Upload',
    isEnabled: false,
    validationFields: ['uploadedFiles'],
    category: 'Records & Data',
  },
];

export const PROFILE_ICON_COLORS = [
  {
    name: 'DEFAULT_GREEN',
    color: '#10B981',
  },
  {
    name: 'DEFAULT_BLUE',
    color: '#3B82F6',
  },
  {
    name: 'DEFAULT_INDIGO',
    color: '#6366F1',
  },
  {
    name: 'DEFAULT_PURPLE',
    color: '#8B5CF6',
  },
  {
    name: 'DEFAULT_PINK',
    color: '#EC4899',
  },
  {
    name: 'DEFAULT_RED',
    color: '#EF4444',
  },
  {
    name: 'DEFAULT_YELLOW',
    color: '#F59E0B',
  },

  {
    name: 'DEFAULT_GRAY',
    color: '#6B7280',
  },
];
